import axios from 'axios'
import { BEARER } from './authorization'
import { notification } from './notification'

let notify = false
axios.interceptors.request.use((config) => {
    notify = !config.url.includes('/auth') && (config.method == 'post' || config.method == 'put')
    return config
}, null)
axios.interceptors.response.use((response) => {
    if (notify) {
        notification.success({})
    }
    return response;
}, null);
window.axios = axios

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

if (BEARER) {
    window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + BEARER
}
